import { PlusCircleIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { GenericTable } from '@/modules/common';

import { useCollarTab } from './hooks/use-collar-tab';

export function CollarTab() {
  const { columns, fields, onAdd } = useCollarTab();

  return (
    <div>
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Liner Colors</h3>
        <Button
          data-testid="add-collar-button"
          onClick={onAdd}
          startIcon={<PlusCircleIcon size={16} />}
        >
          Add Liner Color
        </Button>
      </div>
      <GenericTable
        name="collarColors"
        key="collar-table"
        columns={columns}
        data={fields}
        emptyCellClassName="h-20"
        tableCellClassName="py-1"
        tableRowClassName="hover:bg-transparent"
        disabledColumnsIdsToClick={['name', 'hex', 'actions']}
        emptyTitle="No liner colors yet"
        emptyDescription="Start adding liner colors."
        emptyButton={
          <Button
            data-testid="add-collar-button"
            onClick={onAdd}
            startIcon={<PlusCircleIcon size={16} />}
          >
            Add Liner Color
          </Button>
        }
      >
        <p className="text-zinc-400 text-sm">
          All liner colors: {fields.length}
        </p>
      </GenericTable>
    </div>
  );
}
